import { getCore } from '../../../client/core/getCore';
import { getDefaultClient } from '../../../client/defaultClient';
import { createApiClient } from '../../apiClient';
import { logout } from '../../auth/logout';

export const revokeAllRegisteredDevices = async (
  client = getDefaultClient()
): Promise<void> => {
  const core = getCore(client);
  const apiClient = createApiClient({}, client);

  await apiClient.deleteAllDeviceRegistrations({
    environmentId: core.environmentId,
  });

  await logout(client);
};
